import { Component, Host, OnDestroy, OnInit, Renderer2, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FrontendComponent } from '../frontend.component';
import { ArrayHelper } from '../../../models/helpers/array-helper';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy {
    countries: string[] = [];

    searchText: string;
    country: string;
    minDate = new Date(2014, 1);
    nowDate = new Date;
    maxDate = new Date(this.nowDate.getFullYear(),1);
    date: Date;

    readonly generalPlaceholderPC = 'Search by planting site, certificate, name, or customer ID';
    private readonly generalPlaceholderNotPC = 'Search';
    private readonly maxTabletSizePx = 768;

    generalSearchPlaceHolder = this.generalPlaceholderPC;

    @HostListener('window:resize')
    onResize() {
        this.generalSearchPlaceHolder = this.setSearchPlaceholder();
    }

    private setSearchPlaceholder(): string{
        if (window.innerWidth < this.maxTabletSizePx)
            return this.generalPlaceholderNotPC;
        else
            return this.generalPlaceholderPC;
    }

    constructor(private route: ActivatedRoute,
                private renderer: Renderer2,
                @Host() private frontendComponent: FrontendComponent,
                private router: Router) {
        this.frontendComponent.showBackgroundImage = true;
    }

    ngOnInit() {
        this.generalSearchPlaceHolder = this.setSearchPlaceholder();
        this.route.data.subscribe(data => {
            this.countries = ArrayHelper.sortBy(data.countries || [], true, s => s);
        });
    }

    log(v) {
        console.log(v);
    }

    ngOnDestroy(): void {
        this.frontendComponent.showBackgroundImage = false;
    }

    toSearch() {
        this.router.navigate(['/plantingSite', 'list', 'map'], {queryParams: {search: this.searchText}});
    }

    setCountry(value: any) {
        this.country = typeof value === 'string' ? value : undefined;
    }
}
